export default {
      id: "audit-usage",
      viewBox: "0 0 74 44",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#audit",
      toString: function () {
        return this.url;
      }
    }